/**
 * トップページ: ランキングセクション
 */

/**
 * ランキングセクションの初期化
 * @param {jQuery} $ - jQuery
 */
export function initRanking($) {
  const $buttons = $('.s-home__ranking-btn');

  if ($buttons.length === 0) return;

  $buttons.on('click', function () {
    const ranking = $(this).data('ranking');
    const $currentList = $('.s-home__ranking-item:visible');
    const $nextList = $('.s-home__ranking-item--' + ranking);

    // 同じリストがクリックされた場合は何もしない
    if ($currentList.is($nextList)) {
      return;
    }

    // ボタンの状態を更新
    $buttons.removeClass('active');
    $(this).addClass('active');

    // 初回表示時
    if ($currentList.length === 0) {
      $nextList.addClass('active').fadeIn(150);
      return;
    }

    // フェードアウト → フェードイン
    $currentList.fadeOut(150, function () {
      $currentList.removeClass('active');
      $nextList.addClass('active').fadeIn(150);
    });
  });
}
